import { useState } from 'react';
import { ChevronDown, StickyNote } from 'lucide-react';
import { FONT_BODY } from '../theme';
import { Card } from '../ui';

/* Day notes, folded away by default. They're worth keeping, but they're
 * reference material you touch occasionally -- left open, two textareas sat
 * between the totals and the food itself and pushed the actual log below the
 * fold on every visit. */
export function DailyNoteCard({ t, note, onChange }) {
  const [open, setOpen] = useState(false);
  const food = String(note.food || '').trim();
  const goal = String(note.goal || '').trim();
  const preview = food || goal;

  if (!open) {
    return (
      <button onClick={() => setOpen(true)} style={{
        width: '100%', textAlign: 'left', cursor: 'pointer',
        background: 'transparent', border: `1px dashed ${t.cardBorder}`, borderRadius: 10,
        padding: '10px 14px', display: 'flex', alignItems: 'center', gap: 8,
        color: t.textMuted, fontFamily: FONT_BODY, fontSize: 12.5, fontWeight: 600,
      }}
        onMouseEnter={e => e.currentTarget.style.background = t.surfaceAlt}
        onMouseLeave={e => e.currentTarget.style.background = 'transparent'}>
        <StickyNote size={14} style={{ flexShrink: 0 }} />
        <span style={{ flexShrink: 0 }}>{preview ? 'Day note' : 'Add a day note'}</span>
        {preview && (
          <span style={{ minWidth: 0, fontWeight: 400, color: t.textFaint, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
            &mdash; {preview}
          </span>
        )}
      </button>
    );
  }

  return (
    <Card t={t} padding={18}>
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 12 }}>
        <div style={{ fontSize: 14, fontWeight: 700, color: t.text, display: 'flex', alignItems: 'center', gap: 8 }}>
          <StickyNote size={15} /> Day note
        </div>
        <button onClick={() => setOpen(false)} title="Collapse" style={{ background: 'transparent', border: 'none', cursor: 'pointer', color: t.textFaint, padding: 4, display: 'flex' }}>
          <ChevronDown size={18} style={{ transform: 'rotate(180deg)' }} />
        </button>
      </div>
      <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
        <label style={{ display: 'flex', flexDirection: 'column', gap: 6, fontSize: 12, fontWeight: 600, color: t.textMuted }}>
          Meal context
          <textarea autoFocus value={note.food || ''} onChange={event => onChange('food', event.target.value)} rows={3}
            placeholder='What did you eat that is not clear from the log?'
            style={{ width: '100%', resize: 'vertical', background: t.inputBg, color: t.text, border: '1px solid ' + t.inputBorder, borderRadius: 8, padding: '9px 10px', fontFamily: FONT_BODY, fontSize: 13, lineHeight: 1.45, outline: 'none' }} />
        </label>
        <label style={{ display: 'flex', flexDirection: 'column', gap: 6, fontSize: 12, fontWeight: 600, color: t.textMuted }}>
          Why did I miss my target?
          <textarea value={note.goal || ''} onChange={event => onChange('goal', event.target.value)} rows={3}
            placeholder='e.g. no time to cook, appetite was low, ate out, training ran late'
            style={{ width: '100%', resize: 'vertical', background: t.inputBg, color: t.text, border: '1px solid ' + t.inputBorder, borderRadius: 8, padding: '9px 10px', fontFamily: FONT_BODY, fontSize: 13, lineHeight: 1.45, outline: 'none' }} />
        </label>
      </div>
    </Card>
  );
}
